import * as d3 from "d3";
import {
    colonAnnotation, contextMenu,
    createTooltip,
    fw_progressive_1way,
    generateDownloadData,
    inrFormatter,
    responsivefy
} from '../functions'

export default function (chart, divId, vizName, resData,filterParam) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    // axios.post(url, filterParam).then(res => {
    let data = resData
    var renameKeys = function (obj) {

        obj.name = obj.key;
        delete obj.key;
        if (obj.values) {
            obj.children = obj.values;
            delete obj.values;
            obj.children.forEach(renameKeys);
        }
        return obj;
    };

    var nest = d3.nest()
        .key(function (d) {
            return d.dim2_name;
        })//.sortKeys(d3.ascending)
        .key(function (d) {
            return d.dim3_name;
        })//.sortKeys(d3.ascending)
        .rollup(function (v) {
            return d3.sum(v, function (d) {
                return d.metric1;
            })
        })
        // .rollup(function(v) {
        //     return {
        //         sum: d3.sum(v, function (d) {
        //             return d.metric1;
        //         }),
        //         pct: d3.sum(v, function (d) {
        //             return d.metric2;
        //         })
        //     }
        // })
        .entries(data);

    console.log("Nested Data", nest)


    // console.log("nestmult")
    /*The visualization requires there to be a root node*/
    var flareData = {key: chart.x1AxisDisplayName, values: []};
    flareData.values = nest;
    console.log("Flare Data", flareData)
    renameKeys(flareData);


    (function visualize(dataset) {
        var graph = d3.hierarchy(flareData).sum((d) => d.value)
        var nodes = flatten(graph);
        console.log("nodes", nodes)
        var links = graph.links();
        var i = 0

        console.warn(i, dataset)

        var svg = d3.select(divId).select("svg").remove();

        svg = d3.select(divId).append("svg")
            .attr("class", "scroll")
            .attr("width", chart.width + chart.margin.left + chart.margin.right)
            .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append("g")

        //    var colorMetric ;
        //                    switch(true) {
        //                        case chart.vizSpecific5 == 'singleblue': {
        //                            colorMetric = 'd3.schemeBlues[5]'
        //                            break;
        //                        }
        //                        case chart.vizSpecific5 == 'singlered': {
        //                            colorMetric = 'd3.schemeReds[5]'
        //                            break;
        //                        }
        //                    }
        // //   var metric1ColorScale = d3.scaleOrdinal(fw_progressive_1way)
        //
        //   console.log("colorMetric",colorMetric)

        //   var metric1ColorScale = d3.scaleLinear(d3.schemeBlues[5])
        // //  .range(d3.schemeBlues)
        //   .domain([d3.min(nodes, (d) =>{ return d.value }),
        //       d3.max(nodes, (d) =>{ return d.value })]);


        var metric1ColorScale = d3.scaleOrdinal(fw_progressive_1way)


        //  var radius = d3.scaleSqrt().range([0, 6]);

        var radius = d3.scaleSqrt()
            .domain([d3.min(nodes, function (d) {
                return d.value
            }),
                d3.max(nodes, function (d) {
                    return d.value
                })])
            .range([1, 70]);


        var simulation = d3.forceSimulation()
            .force("link",
                d3.forceLink().id(function (d) {
                    return d.name;
                })
                    .distance(150)
                    .strength(function () {
                        return 2;
                    })
            )
            .force("charge", d3.forceManyBody().strength(-200))
            .force("collide", d3.forceCollide().radius(function (d) {
                return radius(d.value / 2) + 5;
            }))
            .force("center", d3.forceCenter(chart.width / 2, chart.height / 2));

        var link = svg.append("g")
            .attr("class", "links")
            .selectAll("path")
            .data(links)
            .enter().append("svg:path")
            .attr("stroke-width", function () {
                return 3
            });

        link.style('fill', 'none').style('stroke', 'black').style("stroke-width", '2px');

        // Create tooltip
        const tooltip = createTooltip(divId);

        // Calculate the center of the chart
        const effectiveWidth = chart.width - chart.margin.left - chart.margin.right;
        const centerX = chart.margin.left + effectiveWidth / 2;
        const centerY = chart.margin.top + (chart.height - chart.margin.top - chart.margin.bottom) / 2;

        // Define nodes
        var node = svg.append("g")
            .attr("class", "nodes-mis")
            .selectAll("g")
            .data(nodes)
            .enter().append("g")
            .style('transform-origin', '50% 50%')
            .call(d3.drag()
                .on("start", dragstarted)
                .on("drag", dragged)
                .on("end", dragended)
            )
            .on('mouseover', function (d) {
                tooltip.onMouseOver(d, this, function (d) {
                    return chart.y1MetricTooltip + colonAnnotation + inrFormatter(d.value);
                });
            })
            .on('mousemove', function (event) {
                tooltip.onMouseMove(event);
            })
            .on('mouseout', function () {
                tooltip.onMouseLeave();
            })
            .on('contextmenu', function (d) {
                console.log(d)
                const dimensionKey =
                    d.depth === 1 ? [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName] :
                        d.depth === 2 ? [chart.insightNavigator.realDataFieldNames.x2RealDataFieldName] :
                            [chart.insightNavigator.realDataFieldNames.y2RealDataFieldName];
                const clickedData = {
                    [dimensionKey]: [d.data.name],
                };
                console.log("clickedData", clickedData);
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);
                contextMenu(menuItems).call(this, clickedData);
                d3.event.preventDefault();
            });

        // Append circles
        node.append('circle')
            .attr("r", (d) => radius(d.value))
            .style('fill', (d) => metric1ColorScale(d.data.name))
            .style("stroke", "#fff")
            .style("stroke-width", "1.5px");

        // Append text for non-leaf nodes (centered)
        node.append("text")
            .filter(d => d.children)
            .attr("dy", ".35em")
            .attr("text-anchor", "middle")
            .text(d => d.data.name);

        // Append text for leaf nodes
        const leafText = node.append("text")
            .filter(d => !d.children) // Only leaf nodes
            .attr("dy", ".35em")
            .text(d => d.data.name);

        // Initialize simulation
        simulation.nodes(nodes).on("tick", ticked);
        simulation.force("link").links(links);

        function ticked() {
            link.attr("d", function (d) {
                var dx = d.target.x - d.source.x,
                    dy = d.target.y - d.source.y,
                    dr = Math.sqrt(dx * dx + dy * dy);
                return (
                    "M" +
                    d.source.x +
                    "," +
                    d.source.y +
                    "A" +
                    dr +
                    "," +
                    dr +
                    " 0 0,1 " +
                    d.target.x +
                    "," +
                    d.target.y
                );
            });

            node.attr("transform", function (d) {
                return "translate(" + d.x + "," + d.y + ")";
            });

            // Update leaf node text positions
            leafText
                .attr("x", d => {
                    // Calculate angle from node to center
                    const angleRad = Math.atan2(d.y - centerY, d.x - centerX);
                    // Position text at radius + 5 units from node center
                    return Math.cos(angleRad) * (radius(d.value) + 5);
                })
                .attr("y", d => {
                    const angleRad = Math.atan2(d.y - centerY, d.x - centerX);
                    return Math.sin(angleRad) * (radius(d.value) + 5);
                })
                .attr("text-anchor", d => {
                    // Convert angle to degrees for text-anchor logic
                    const angleDeg = Math.atan2(d.y - centerY, d.x - centerX) * 180 / Math.PI;
                    // Normalize angle to 0-360
                    const normalizedAngle = (angleDeg + 360) % 360;
                    // Align text: right for 0°-90° and 270°-360°, left for 90°-270°
                    return (normalizedAngle > 90 && normalizedAngle < 270) ? "end" : "start";
                });
        }

        function dragstarted(d) {
            if (!d3.event.active) simulation.alphaTarget(0.3).restart();
            d.fx = d.x;
            d.fy = d.y;
        }

        function dragged(d) {
            d.fx = d3.event.x;
            d.fy = d3.event.y;
        }

        function dragended(d) {
            if (!d3.event.active) simulation.alphaTarget(0);
            d.fx = null;
            d.fy = null;
        }

        function flatten(root) {
            var nodes = [];
            var i = 0;
            function recurse(node) {
                if (node.children) node.children.forEach(recurse);
                if (!node.id) node.id = ++i;
                else ++i;
                nodes.push(node);
            }
            recurse(root);
            return nodes;
        }
    })(flareData)
}